/*
 * Public API Surface of collection-points
 */

export * from './pages/collection-points.component';
export * from './lib/collection-points.module';
